<template lang="pug">
  .technicalInputs
    el-radio-group(
      v-bind:value="technicalAssumptionsSwitch"
      v-on:input="$emit('switchChange', $event)"
    )
      el-radio-button(label="Base Case")
      el-radio-button(label="User Case")

    el-collapse(
      v-model="activeTechnicalCollapse"
      accordion=true
    )
      el-collapse-item(
        title="Grade"
        name="1"
      )
        slider(
          :min="0"
          :step="0.1"
          :max="5"
          v-model='technicalInputs.heapLeachGoldGrade'
          title='Heap Leach Gold Grade'
          :hide='true'
          :baseValue='baseCaseTechnicalAssumptions.heapLeachGoldGrade'
          :precision='3'
        )
        slider(
          :min="0"
          :step="0.0005"
          :max=".05"
          v-model='technicalInputs.millCopperGrade'
          title='Mill Copper Grade (%)'
          :hide='true'
          type='percent'
          :baseValue='baseCaseTechnicalAssumptions.millCopperGrade'
          :precision='4'
        )
        slider(
          :min="0"
          :step="0.1"
          :max="10"
          v-model='technicalInputs.millGoldGrade'
          title='Mill Gold Grade (g/t)'
          :hide='true'
          :baseValue='baseCaseTechnicalAssumptions.millGoldGrade'
          :precision='3'
        )
        slider(
          :min="0"
          :step="0.0001"
          :max=".005"
          v-model='technicalInputs.millMolybdenumGrade'
          title='Mill Molybdenum Grade (%)'
          type='percent'
          :hide='true'
          :baseValue='baseCaseTechnicalAssumptions.millMolybdenumGrade'
          :precision='5'
        )
        slider(
          :min="0"
          :step="0.000001"
          :max="0.00005"
          v-model='technicalInputs.millRheniumGrade'
          title='Mill Rhenium Grade (%)'
          type='percent'
          :hide='true'
          :baseValue='baseCaseTechnicalAssumptions.millRheniumGrade'
          :precision='6'
        )
        slider(
          :min="0"
          :step="0.5"
          :max="20"
          v-model='technicalInputs.heapLeachSilverGrade'
          title='Heap Leach Silver Grade (g/t)'
          :hide='true'
          :baseValue='baseCaseTechnicalAssumptions.heapLeachSilverdGrade'
          :precision='3'
        )
        slider(
          :min="0"
          :step="0.5"
          :max="100"
          v-model='technicalInputs.millSilverGrade'
          title='Mill Silver Grade (g/t)'
          :hide='true'
          :baseValue='baseCaseTechnicalAssumptions.millSilverGrade'
          :precision='3'
        )
      el-collapse-item(
        title="Metallurgy"
        name="2"
      )
        slider(
          :min="0"
          :step="0.01"
          :max="1"
          v-model='technicalInputs.heapLeachGoldRecovery'
          :hide='true'
          title='Heap Leach Gold Recovery (%)'
          :baseValue='baseCaseTechnicalAssumptions.heapLeachGoldRecovery'
          type='percent'
          :precision='3'
        )
        slider(
          :min="0"
          :step="0.01"
          :max="1"
          v-model='technicalInputs.millGoldRecovery'
          :hide='true'
          title='Mill Gold Recovery (%)'
          :baseValue='baseCaseTechnicalAssumptions.millGoldRecovery'
          type='percent'
          :precision='3'
        )
        slider(
          :min="0"
          :step="0.01"
          :max="1"
          v-model='technicalInputs.heapLeachSilverRecovery'
          :hide='true'
          title='Heap Leach Silver Recovery (%)'
          :baseValue='baseCaseTechnicalAssumptions.heapLeachSilverRecovery'
          type='percent'
          :precision='3'
        )
        slider(
          :min="0"
          :step="0.01"
          :max="1"
          v-model='technicalInputs.millSilverRecovery'
          :hide='true'
          title='Mill Silver Recovery (%)'
          :baseValue='baseCaseTechnicalAssumptions.millSilverRecovery'
          type='percent'
          :precision='3'
        )
        slider(
          :min="0"
          :step="0.01"
          :max="1"
          v-model='technicalInputs.millCopperRecovery'
          :hide='true'
          title='Mill Copper Recovery (%)'
          :baseValue='baseCaseTechnicalAssumptions.millCopperRecovery'
          type='percent'
          :precision='3'
        )
        slider(
          :min="0"
          :step="0.01"
          :max="1"
          v-model='technicalInputs.millMolybdenumRecovery'
          :hide='true'
          title='Mill Molybdenum Recovery (%)'
          :baseValue='baseCaseTechnicalAssumptions.millMolybdenumRecovery'
          type='percent'
          :precision='3'
        )
        slider(
          :min="0"
          :step="0.01"
          :max="1"
          v-model='technicalInputs.millRheniumRecovery'
          :hide='true'
          title='Mill Rhenium Recovery (%)'
          :baseValue='baseCaseTechnicalAssumptions.millRheniumRecovery'
          type='percent'
          :precision='3'
        )
      el-collapse-item(
        title="Mining"
        name="3"
        v-if="baseCaseTechnicalAssumptions.stripRatio!=0"
      )
        slider(
          :min="0"
          :step="0.1"
          :max="10"
          v-model='technicalInputs.stripRatio'
          :hide='true'
          title='Strip Ratio'
          :baseValue='baseCaseTechnicalAssumptions.stripRatio'
          :precision='3'

        )

      el-collapse-item(
        title="Unit Costs"
        name="4"
      )
        slider(
          :min="0"
          :step="0.05"
          :max="4"
          v-model='technicalInputs.openPitMiningCostPerTonneMined'
          :hide='true'
          title='Open Pit Mining Cost per Tonne Mined (US$/t)'
          :baseValue='baseCaseTechnicalAssumptions.openPitMiningCostPerTonneMined'
          :precision='2'
        )
        slider(
          :min="0"
          :step="0.05"
          :max="120"
          v-model='technicalInputs.undergroundMiningCostPerTonneMined'
          :hide='true'
          title='Underground Mining Cost per Tonne Mined (US$/t)'
          :baseValue='baseCaseTechnicalAssumptions.undergroundMiningCostPerTonneMined'
          :precision='2'
        )
        slider(
          :min="0"
          :step="0.05"
          :max="4"
          v-model='technicalInputs.heapLeachProcessCostPerTonneProcessed'
          :hide='true'
          title='Heap Leach Process Cost per Tonne Processed (US$/t)'
          :baseValue='baseCaseTechnicalAssumptions.heapLeachProcessCostPerTonneProcessed'
          :precision='2'
        )
        slider(
          :min="0"
          :step="0.25"
          :max="40"
          v-model='technicalInputs.millProcessCostPerTonneProcessed'
          :hide='true'
          title='Mill Process Cost per Tonne Processed (US$/t)'
          :baseValue='baseCaseTechnicalAssumptions.millProcessCostPerTonneProcessed'
          :precision='2'
        )
        slider(
          :min="0"
          :step="0.05"
          :max="30"
          v-model='technicalInputs.gAndACostPerTonneProcessed'
          :hide='true'
          title='G&A and Other Costs per Tonne Processed (US$/t)'
          :baseValue='baseCaseTechnicalAssumptions.gAndACostPerTonneProcessed'
          :precision='2'
        )

      el-collapse-item(
        title="Capital"
        name="5"
      )
        slider(
          :min="-0.3"
          :step="0.05"
          :max="0.3"
          v-model='technicalInputs.preProductionCapexVariance'
          :hide='false'
          title='Pre-Production Capex Variance'
          type='percent'
          :precision='2'
        )
        slider(
          :min="-0.3"
          :step="0.05"
          :max="0.3"
          v-model='technicalInputs.sustainingCapexVariance'
          :hide='false'
          title='Sustaining Capex Variance'
          type='percent'
          :precision='2'
        )
</template>

<script>
import Slider from '@/components/slider'

export default {
  name: 'TechnicalInputs',
  props: ['technicalInputs', 'baseCaseTechnicalAssumptions', 'technicalAssumptionsSwitch'],
  components: { Slider },
  data: function () {
    return {
      activeTechnicalCollapse: 0
    }
  }
}
</script>

<style scoped lang="stylus">

</style>
